import React from "react";

import { useTheme } from "../../../../../context/theme";
import { Box } from "../../../../layout";
import { MaxWidth, maxWidthMap } from "./consts";

import type {
  ResponsiveDimension,
  Overflow,
  Dimension
} from "../../../../../types";

export type Props = {
  children: React.ReactNode;
  maxWidth?: MaxWidth;
  fullscreen?: boolean;
  fullscreenOnMobile?: boolean;
  scrollable?: boolean;
  padding?: ResponsiveDimension;
  overflowY?: Overflow;
  background?: string;
  zIndex?: number;
};

export default function ModalContent({
  children,
  maxWidth = "medium",
  fullscreen = true,
  fullscreenOnMobile,
  scrollable = true,
  padding = "xxlarge",
  overflowY,
  background,
  zIndex
}: Props) {
  const theme = useTheme();

  const modalStyles = fullscreenOnMobile
    ? {
        height: ["100%", "unset"] as [string, string],
        borderRadius: ["none", "large"] as ResponsiveDimension
      }
    : { height: "unset", borderRadius: "large" as Dimension };

  return (
    <Box
      maxWidth={maxWidthMap[maxWidth]}
      width="100%"
      paddingY={padding}
      paddingX={["xlarge", padding as Dimension]}
      position={fullscreen ? "fixed" : "absolute"}
      overflowY={overflowY || (scrollable ? "auto" : "hidden")}
      left="50%"
      top="50%"
      maxHeight={["100%", "90%"]}
      transform="translate(-50%, -50%)"
      margin="auto"
      backgroundColor={theme.foreground}
      background={background}
      zIndex={zIndex ?? fullscreenOnMobile ? 2 : undefined}
      {...modalStyles}
      dataTest="Modal"
    >
      {children}
    </Box>
  );
}
